import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Brackets Curly Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M43.18 128a29.8 29.8 0 0 1 8 10.26c4.8 9.9 4.8 22 4.8 33.74 0 24.31 1 36 24 36a8 8 0 0 1 0 16c-17.48 0-29.32-6.14-35.2-18.26-4.8-9.9-4.8-22-4.8-33.74 0-24.31-1-36-24-36a8 8 0 0 1 0-16c23 0 24-11.69 24-36 0-11.72 0-23.84 4.8-33.74C50.68 38.14 62.52 32 80 32a8 8 0 0 1 0 16c-23 0-24 11.69-24 36 0 11.72 0 23.84-4.8 33.74A29.8 29.8 0 0 1 43.18 128M240 120c-23 0-24-11.69-24-36 0-11.72 0-23.84-4.8-33.74C205.32 38.14 193.48 32 176 32a8 8 0 0 0 0 16c23 0 24 11.69 24 36 0 11.72 0 23.84 4.8 33.74a29.8 29.8 0 0 0 8 10.26 29.8 29.8 0 0 0-8 10.26c-4.8 9.9-4.8 22-4.8 33.74 0 24.31-1 36-24 36a8 8 0 0 0 0 16c17.48 0 29.32-6.14 35.2-18.26 4.8-9.9 4.8-22 4.8-33.74 0-24.31 1-36 24-36a8 8 0 0 0 0-16" }, null, -1)
  ]))]))
}
export default { render: render }